var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"arrow-img",staticStyle:{"background-color":"#FFFFFF"}}),_vm._v(" "),_c('div',{staticClass:"box"},[_c('img',{attrs:{"src":require("../../../static/no-log.png"),"alt":""}}),_vm._v(" "),_c('span',[_vm._v("无账号可迁入")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70b8bc91","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/noAccount/index.vue
// module id = null
// module chunks = 